import { includes } from "@/utils/objects";

/*
 * 日本睡眠学会専門医療機関 リスト
 * https://docs.google.com/spreadsheets/d/1N-6oJItUZRBltc3grWZIRVMtq0evugHoYlPrUCGIqXY/edit?gid=0#gid=0
 */
const HOSPITAL_DATA = `No	都道府県	(施設名) (認定区分・番号) （代表者）	郵便番号	住所	電話番号	HP(=引用元)	参照日	地方(八地方区分)	選定療養費
1	北海道	医療法人社団ウェルネス望洋台医院 機関 A-0017-4 藤田 雅彦	〒047-0155	北海道小樽市望洋台2丁目2-13	0134-54-1199	https://sleepdoc.or.jp/	2024/12/17	北海道	閉業
2	北海道	特定医療法人社団慶愛会札幌花園病院 機関 A-0132 本間 さと	〒064-0915	北海道札幌市中央区南15条西15丁目1番30号	011-561-6131	http://www.hanazono-hp.or.jp/	2024/12/17	北海道	不要
3	北海道	医療法人社団慈藻会 平松記念病院 睡眠医療センター 機関 A-0121 佐川 洋平	〒064-0922 	北海道札幌市中央区南22条西14丁目1−20	011-561-0708	https://hiramatu-mhp.or.jp/	2024/12/17	北海道	不要
4	秋田県	秋田大学医学部附属病院 精神科 機関 A-0029-4 三島 和夫	〒010-8543 	秋田県秋田市広面字蓮沼44-2	018-834-1111	https://www.hos.akita-u.ac.jp/index.html	2024/12/17	東北	要
5	岩手県	岩手医科大学附属病院 睡眠医療科 機関 A-0110-1 西島 嗣生	〒028-3695　	岩手県紫波郡矢巾町医大通二丁目1番1号	019-613-7111	https://www.hosp.iwate-med.ac.jp/yahaba/	2024/12/17	東北	要
6	宮城県	一般財団法人東北精神保健会 青葉病院 機関 A-0127 菅野 道	〒983-0836 	宮城県仙台市宮城野区幸町三丁目15番20号	022-257-7586	http://www.aobahp.or.jp/	2024/12/17	東北	不要
7	宮城県	東北大学病院 睡眠医療センター 機関 A-0137 小川 浩正	〒980-8574 	宮城県仙台市青葉区星陵町1番1号	022-717-7000	https://www.hosp.tohoku.ac.jp/	2024/12/17	東北	要
8	福島県	(財)太田綜合病院附属太田西ノ内病院総合睡眠医療センター 機関 A-0008-4 松浦 圭文	〒963-8558 	福島県郡山市西ノ内2-5-20	024-925-1188	https://www.ohta-hp.or.jp/nishi/	2024/12/17	東北	要
9	福島県	ささき内科クリニック 機関 A-0044-3 佐々木 満	〒971-8185	福島県いわき市泉町3-1-2	0246-75-0081	http://www.gem.hi-ho.ne.jp/ibiki/	2024/12/17	東北	不要
10	福島県	医療法人健眠会 大槻スリープクリニック 機関 A-0084-3 大槻 学	〒960-8044 	福島県福島市早稲町4番1号 Sleep one ビル2F	024-526-0084	http://otsukisleep.jp/	2024/12/17	東北	不要
11	栃木県	獨協医科大学病院睡眠医療センター 機関 A-0004-4 宮本 雅之	〒321-0293 	栃木県下都賀郡壬生町大字北小林880	0282-86-1111	https://www.dokkyomed.ac.jp/hosp-m/	2024/12/17	関東	要
12	栃木県	医療法人社団幸仁会 たかしま耳鼻咽喉科 機関 A-0101-2 高島 雅之	〒320-0042 	栃木県宇都宮市材木町1-7 	028-633-9115	https://www.takashima-cl.com/	2024/12/17	関東	不要そう
13	群馬県	医療法人高柳会赤城病院 機関 A-0130 関口 秀文	〒371-0002	群馬県前橋市江木町1072	027-269-5111	https://tyk.or.jp/	2024/12/17	関東	不要
14	埼玉県	医療法人康曜会プラーナクリニック 機関 A-0124 青木 康弘	〒366-0817	埼玉県深谷市柏合144-2	048-551-1500	https://sites.google.com/site/pranaclinic/	2024/12/17	関東	不要
15	埼玉県	すなおクリニック 精神科 機関 A-0134 内田 直	〒330-0846 	埼玉県さいたま市大宮区大門町2丁目94 福呂屋ビル4階	048-783-5607	https://sunao.clinic/	2024/12/17	関東	不要
16	東京都	東京慈恵会医科大学附属病院 機関 A-0027-4 繁田 雅弘	〒105-8471 	東京都港区西新橋3-19-18	0570-03-2222	https://www.hosp.jikei.ac.jp/	2024/12/17	関東	要
17	東京都	財団法人神経研究所付属睡眠呼吸障害クリニック 機関 A-0034-4 福原 俊明	〒101-0061 	東京都千代田区神田三崎町2-18-11-2F	03-3556-9181	https://www.suiminclinic.com/	2024/12/17	関東	不要
18	東京都	医療法人社団絹和会睡眠総合ケアクリニック代々木 機関 A-0037-4 井上 雄一	〒151-0053 	東京都渋谷区代々木5丁目10-10	03-6300-5401	https://www.somnology.com/	2024/12/17	関東	不要
19	東京都	虎の門病院 睡眠センター 機関 A-0040-3 笠木 聡	〒105-8470 	東京都港区虎ﾉ門二丁目2番2号	03-3588-1111	https://toranomon.kkr.or.jp/	2024/12/17	関東	要
20	東京都	医療法人社団グッドスリープグッドスリープ・クリニック 機関 A-0057-3 齋藤 恒博	〒105-0012	東京都港区芝大門2丁目10番1号　第一大門ビル1階	03-5733-3251	https://www.good-sleep.gr.jp/	2024/12/17	関東	不要
21	東京都	東邦大学医療センター大森病院 睡眠時呼吸障害センター 機関 A-0076-3 髙井雄二郎	〒143-8541 	東京都大田区大森西6-11-1	03-3762-4151	https://www.lab.toho-u.ac.jp/med/omori/sdb/index.html	2024/12/17	関東	要
22	東京都	日本大学医学部附属板橋病院 睡眠センター 機関 A-0077-3 陳 和夫	〒173-8610 	東京都板橋区大谷口上町30番1号	03-3972-8111	https://www.itabashi.med.nihon-u.ac.jp/sleep_center/	2024/12/17	関東	要
23	東京都	国立精神・神経医療研究センター病院 機関 A-0090-2 栗山 健一	〒187-8551	東京都小平市小川東町4-1-1	042-341-2711	https://www.ncnp.go.jp/hospital/	2024/12/17	関東	要
24	東京都	医療法人社団玉栄会 東京天使病院 機関 A-0100-2 玉谷 青史	〒193-0811	東京都八王子市上壱分方町50-1	042-651-5331	https://angelcourt.or.jp/	2024/12/17	関東	不要
25	東京都	東京女子医科大学病院 睡眠科 機関 A-0104-2 鈴木真由美	〒162-8666　	東京都 新宿区 河田町 8-1	03-3353-8111	https://www.twmu.ac.jp/info-twmu/syoshin.html	2024/12/17	関東	要
26	東京都	医療法人社団慶真記念会 新宿睡眠・呼吸器内科クリニック 機関 A-0105-2 赤星 俊樹	〒163-1312 	東京都新宿区西新宿6-5-1 新宿アイランドタワー12F	03-5909-5588	https://www.shinjuku-sleep.jp/	2024/12/17	関東	不要
27	東京都	東京睡眠医学センター スリープクリニック調布 機関 A-0114-1 遠藤 拓郎	〒182-0026	東京都調布市小島町2-53-1	0424-900-700	https://www.sleepmedicine-tokyo.com/	2024/12/18	関東	不要
28	東京都	杏林大学医学部付属病院 精神神経科 機関 A-0115-1 中島 亨	〒181-8611	東京都三鷹市新川6-20-2	0422-47-5511	https://www.kyorin-u.ac.jp/hospital/	2024/12/18	関東	要
29	東京都	医療法人社団 SSC スリープ・サポートクリニック 機関 A-0119-1 林田 健一	〒140-0011 	東京都品川区東大井1-18-8 ミランビーナ1階	03-3471-3020	https://www.sleep-support.jp/	2024/12/18	関東	不要
30	東京都	昭和大学病院附属東病院 睡眠医療センター 機関 A-0123 安達 太郎	〒142-0054 	東京都品川区西中延2-14-19	03-3784-8304	https://showa-sleep.jp/	2024/12/18	関東	不要そう
31	東京都	恵泉第二クリニック 世田谷睡眠呼吸センター 機関 B-0017-3 川原 誠司	〒157-0062	東京都世田谷区南烏山4-12-10 フロンティアビル2階	03-5315-8210	https://www.sleeping.jp/	2024/12/18	関東	不要
32	東京都	東京医科大学病院 循環器内科 機関 B-0020-3 椎名 一紀	〒160-0023　	東京都新宿区西新宿6-7-1	03-3342-6111	https://hospinfo.tokyo-med.ac.jp/	2024/12/18	関東	要
33	東京都	池袋スリープケアクリニック 機関 B-0032-1 金子 泰之	〒171-0022　	東京都豊島区南池袋3丁目14-11　中町ビル1F	03-5956-3838	https://www.sleep-care.jp/	2024/12/18	関東	不要
34	東京都	公益財団法人結核予防会複十字病院 呼吸器内科 機関 B-130 木村 弘	〒204-8522 	東京都清瀬市松山3-1-24	042-491-4111	https://www.fukujuji.org/	2024/12/18	関東	要
35	神奈川県	横浜呼吸器クリニック 機関 A-0032-4 小野 容明	〒221-0835	神奈川県横浜市神奈川区鶴屋町2丁目24-1	045-317-6005	https://www.sas-info.jp/shisetsu/yokohama-cl/	2024/12/18	関東	不要
36	神奈川県	医療法人愛仁会太田総合病院記念研究所附属診療所太田睡眠科学センター　機関 A-0048-3 千葉伸太郎	〒210-0024　	神奈川県川崎市川崎区日進町1-50	044-244-0131	https://ota-sleep.com/	2024/12/18	関東	要
37	神奈川県	ゆき呼吸器内科クリニック 機関 A-0107-2 蜂須賀久喜	〒238-0008 	神奈川県横須賀市大滝町2－15 横須賀東相ビル3Ｆ	046-828-4159	https://yokosukayukisleep.com/	2024/12/18	関東	不要
38	神奈川県	RESM 新横浜 睡眠・呼吸メディカルケアクリニック 機関 A-0113-1 白濱龍太郎	〒222-0033	神奈川県横浜市港北区新横浜3-8-12 丸八新横浜ビル4階	045-475-5155	https://resm.info/	2024/12/18	関東	不要
39	神奈川県	上大岡内科・呼吸器科クリニック 機関 B-a0056-3 鈴木 俊介	〒233-0002 	神奈川県横浜市港南区 上大岡西2-3-6 BLDアルダ3F	045-882-1159	https://www.kamiooka-clinic.com/	2024/12/18	関東	不要
40	新潟県	国立病院機構西新潟中央病院 呼吸器内科 機関 A-0051-3 大平 徹郎	〒950-2085 	新潟県新潟市西区真砂1丁目14番1号	025-265-3171	https://nishiniigata.hosp.go.jp/	2024/12/18	中部	要
41	新潟県	日本歯科大学新潟病院 睡眠歯科センター 機関 B-0001-4 河野 正己	〒951-8580	新潟県新潟市中央区浜浦町1−8	025−267−1500	https://www.ngt.ndu.ac.jp/hospital/	2024/12/18	中部	不要
42	新潟県	新潟臨港病院 機関 B-a0050-3 坂井 邦彦	〒950-8725 	新潟県新潟市東区桃山町1丁目114番地3	025-274-5331	https://ngt-rinkohc.jp/rinko/	2024/12/18	中部	不要
43	富山県	独立行政法人国立病院機構 北陸病院 機関 A-0111-1 細川 宗仁	〒939-1893 	富山県南砺市信末596	0763-62-1340	https://hokuriku.hosp.go.jp/	2024/12/18	中部	不要そう
44	石川県	金沢医科大学病院睡眠医学センター 機関 A-0024-4 堀 有行	〒920-0293 	石川県河北郡内灘町大学1-1	076-286-3511	https://www.kanazawa-med.ac.jp/~hospital/	2024/12/18	中部	要
45	長野県	ＪＡ長野厚生連南長野医療センター 篠ノ井総合病院 機関 A-0066-3 松尾 明美	〒388-8004	長野県長野市篠ノ井会666-1	026-292-2261	https://shinonoi-ghp.jp/	2024/12/18	中部	要
46	長野県	わかまつ呼吸器内科クリニック 機関 A-0108-2 若松 俊秀	〒381-0034	長野県長野市大字高田549−7	026-266-0227	https://www.wakamatsu-cl.com/	2024/12/18	中部	不要
47	静岡県	中東遠総合医療センター 神経内科・睡眠医療センター 機関 A-0074-3 若井 正一	〒436-8555　	静岡県掛川市菖蒲ヶ池1番地の1	0537-21-5555	https://www.chutoen-hp.shizuoka.jp/	2024/12/18	中部	要
48	静岡県	磐田メイツ睡眠クリニック 機関 A-142 柴田 理恵	〒438-0815	静岡県磐田市中田648-1 	0538-39-0300	https://iwata-suimin.com/	2024/12/18	中部	不要
49	静岡県	医療法人社団優仁会 協愛医院 耳鼻咽喉科 機関 B-0036-1 佐野 真一	〒418-0067	静岡県富士宮市宮町8-7	0544-26-2710	https://kyoai-clinic.jp/	2024/12/18	中部	不要
50	愛知県	愛知医科大学病院 睡眠科・睡眠医療センター 機関 A-0005-4 篠邉龍二郎	〒480-1195	愛知県長久手市岩作雁又１番地１	0561-62-3311	https://www.aichi-med-u.ac.jp/hospital/	2024/12/19	中部	要
51	愛知県	藤田医科大学病院 睡眠障害検査室 機関 A-0015-4 北島 剛司	〒470-1192 	愛知県豊明市沓掛町田楽ヶ窪1の98	0562-93-2111	https://www.fujita-hu.ac.jp/~psychi/index.html	2024/12/19	中部	要
52	愛知県	名古屋大学医学部附属病院精神科 親と子どもの心療科 機関 A-0038-4 尾崎 紀夫	〒466-8560 	愛知県名古屋市昭和区鶴舞町65番地	052-741-2111	https://www.med.nagoya-u.ac.jp/hospital/	2024/12/19	中部	要
53	愛知県	豊橋メイツ睡眠クリニック 機関 A-0043-3 小池 茂文	〒440-0036 	愛知県豊橋市東光町50 	0532-66-5678	https://toyohashi-suimin.com/	2024/12/19	中部	不要
54	愛知県	医療法人 SRA たかおかクリニック 機関 A-0081-3 佐々木文彦	〒461-0001	愛知県名古屋市東区泉2-28-24 東和高岳ビル2F	052-979-7700	http://www.takaoka-clinic.jp/	2024/12/19	中部	不要そう
55	愛知県	藤田医科大学ばんたね病院 耳鼻咽喉科 機関 A-0094-2 中田 誠一	〒454-8509 	愛知県名古屋市中川区尾頭橋三丁目6番10号	052-321-8171	https://bantane.fujita-hu.ac.jp/	2024/12/19	中部	要
56	愛知県	名古屋市立大学病院 睡眠医療センター 機関 A-0095-2 佐藤慎太郎	〒467-8602 	愛知県名古屋市瑞穂区瑞穂町字川澄1番地	052-851-5511	https://w3hosp.med.nagoya-cu.ac.jp/	2024/12/19	中部	要
57	愛知県	医療法人康喜会 大竹耳鼻咽喉科・睡眠クリニック 機関 A-0125 大竹 宏直	〒448-0857 	愛知県刈谷市大手町1丁目41番1	0566-23-3341	https://otake-ent.com/	2024/12/19	中部	不要
58	愛知県	医療法人健伸会 はっとり耳鼻咽喉科 機関 B-0019-3 服部 寛一	〒468-0045	愛知県名古屋市天白区野並2-440　野並ビル2階　	052-899-3314	https://www.hattori-ent.com/	2024/12/19	中部	不要
59	愛知県	名古屋セントラル病院耳鼻咽喉科 機関 B-0039-1 山本 浩志	〒453-0801 	愛知県名古屋市中村区太閤3-7-7	052-452-3165	https://nagoya-central-hospital.com/	2024/12/19	中部	不要
60	愛知県	おおたけニコニコクリニック 機関 B-a0079-3 大竹 一生	〒489-0925　	愛知県瀬戸市西寺山町20	0561-86-0086	http://www.otake2525.com/	2024/12/19	中部	不要そう
61	岐阜県	岩永耳鼻咽喉科 中部いびき睡眠障害研究所 機関 A-0068-3 岩永 耕一	〒505-0035　	岐阜県美濃加茂市大手町2-28	0574-25-8749	http://www.ibiki-co.jp/	2024/12/19	中部	不要
62	岐阜県	岐阜メイツ睡眠クリニック 機関 A-0080-3 田中 春仁	〒500-8384	岐阜県岐阜市薮田南4丁目15-20	058-272-9300	https://gifu-sleep.com/	2024/12/19	中部	不要
63	岐阜県	阪野クリニック 機関 A-0099-2 阪野 勝久	〒500-8178	岐阜県岐阜市清住町1-22	058-213-1199	https://banno-clinic.biz/	2024/12/19	中部	不要
64	岐阜県	朝日大学病院 睡眠医療センター 脳神経内科 機関 A-0129 大倉 睦美	〒500-8523 	岐阜県岐阜市橋本町3-23 	058-253-8001	https://www.hosp.asahi-u.ac.jp/	2024/12/19	中部	要
65	岐阜県	はっとりクリニック 機関 B-0015-3 服部 親矢	〒501-0112 	岐阜県岐阜市鏡島精華2丁目4-25	058-252-3200	https://clinic-hattori.jp/	2024/12/19	中部	不要
66	三重県	三重大学医学部附属病院 精神科神経科 機関 A-0065-3 元村 英史	〒514-8507 	三重県津市江戸橋2丁目174	059-232-1111	https://www.hosp.mie-u.ac.jp/	2024/12/19	近畿	要
67	三重県	みたき総合病院 耳鼻咽喉科 機関 B-0028-2 古橋 篤	〒512-0911 	三重県四日市市生桑町菰池458-1	059-330-6000	https://mitaki.or.jp/	2024/12/19	近畿	不要
68	滋賀県	滋賀医科大学医学部附属病院 精神科 機関 A-0012-4 角谷 寛	〒520-2192　	滋賀県大津市瀬田月輪町	077-548-2111	https://www.shiga-med.ac.jp/hospital/index.html	2024/12/19	近畿	要
69	大阪府	大阪回生病院睡眠医療センター 機関 A-0011-4 谷口 充孝	〒532-0003 	大阪府大阪市淀川区宮原1丁目6番10号	06-6393-6234	https://www.kaisei-hp.co.jp/	2024/12/19	近畿	要
70	大阪府	杏和会 阪南病院 機関 A-0041-3 沢田 佐織	〒599-8263 	大阪府堺市中区八田南之町277	072-278-0381	http://www.hannan.or.jp/	2024/12/19	近畿	不要
71	大阪府	医療法人上島医院 神経内科 機関 A-0070-3 渥美 正彦	〒589-0022　	大阪府大阪狭山市西山台1丁目24-20	072-365-6579	https://ueshima-iin.com/	2024/12/19	近畿	不要
72	大阪府	京谷クリニック 機関 A-0131 京谷 京子	〒550-0004 	大阪府大阪市西区靱本町1-4-16　なんぺいビル３F	06-6441-4159	http://www.kyotani.net/	2024/12/19	近畿	不要そう
73	大阪府	関西電力病院 脳神経内科 機関 A-0139 立花 直子	〒553-0003	大阪府大阪市福島区福島2丁目1番7号	06-6458-5821	https://kanden-hsp.jp/	2024/12/19	近畿	要
74	大阪府	ますたに呼吸器クリニック 機関 B-a0055-3 舛谷 仁丸	〒534-0025	大阪府大阪市都島区片町1-5-4 栄ビル4F	06-6351-2322	https://osaka-sleep.com/	2024/12/19	近畿	不要
75	大阪府	大阪大学医学部附属病院 睡眠医療センター 機関 B-a0072-3 池田 学	〒565-0871 	大阪府吹田市山田丘2番15号	06-6879-5111	https://www.hosp.med.osaka-u.ac.jp/	2024/12/19	近畿	要
76	大阪府	小松病院 歯科口腔外科 機関 B-0021-2 田村 仁孝	〒572-8567 	大阪府寝屋川市川勝町11-6	072-823-1521	https://www.komatsu.or.jp/	2024/12/19	近畿	不要
77	京都府	京都大学医学部附属病院 呼吸器内科呼吸管理睡眠制御学 機関 A-0086-2 佐藤 晋	〒606-8507 	京都府京都市左京区聖護院川原町54	075-751-3111	https://www.kuhp.kyoto-u.ac.jp/	2024/12/20	近畿	要
78	京都府	独立行政法人国立病院機構京都医療センター歯科口腔外科 機関 B-0018-3 吉田 和也	〒612-8555	京都府京都市伏見区深草向畑町1-1	075-641-9161	https://kyoto.hosp.go.jp/	2024/12/20	近畿	要
79	京都府	医療法人大岡医院七条診療所 耳鼻咽喉科 機関 B-0127 大岡 久司	〒600-8329 	京都府京都市下京区西洞院通七条上る鍛冶屋町435-1	075-371-3387	https://www.chiryo.jp/shichijo/	2024/12/20	近畿	不要
80	奈良県	済生会奈良病院 内科 睡眠呼吸障害センター 機関 B-0029-1 上森 栄和	〒630-8145 	奈良県奈良市八条4丁目643番地	0742-36-1881	http://www.saiseikai-nara-hp.jp/index.html	2024/12/20	近畿	不要
81	奈良県	奈良県立医科大学附属病院呼吸器・アレルギー・血液内科 機関 B-0034-1 山内 基雄	〒634-8522 	奈良県橿原市四条町840番地	0744-22-3051	https://hospital.naramed-u.ac.jp/	2024/12/20	近畿	要
82	奈良県	独立行政法人国立病院機構奈良医療センター 機関 B-0038-1 田中小百合	〒630-8053	奈良県奈良市七条2丁目789番地	0742-45-4591	https://nara.hosp.go.jp/	2024/12/20	近畿	要
83	兵庫県	医療法人社団前田呼吸器科クリニック 機関 A-0059-3 前田 均	〒651-0084	兵庫県神戸市中央区磯辺通3丁目2-11  三宮ファーストビル２F 	078-251-4159	http://www.maeda4159.net/	2024/12/20	近畿	不要そう
84	兵庫県	姫路聖マリア病院 機関 A-0116-1 小川 晃弘	〒670-0801	兵庫県姫路市仁豊野650	079-265-5111	https://www.himemaria.or.jp/maria/	2024/12/20	近畿	要
85	兵庫県	星野耳鼻咽喉科 睡眠呼吸センター 機関 B-0129 星野 哲朗	〒662-0973　	兵庫県西宮市田中町3丁目1　エイヴィスプラザ２F	0798-35-5965	https://mukokyu.com/	2024/12/20	近畿	不要
86	鳥取県	独立行政法人国立病院機構 鳥取医療センター 機関 A-0039-3 坂本 泉	〒689-0203 	鳥取県鳥取市三津876	0857-59-1111　	https://tottori.hosp.go.jp/	2024/12/20	中国	要
87	鳥取県	鳥取大学医学部附属病院 耳鼻咽喉科 機関 A-0052-3 片岡 英幸	〒683-8504 	鳥取県米子市西町 36-1	0859-33-1111	https://www2.hosp.med.tottori-u.ac.jp/	2024/12/20	中国	要
88	鳥取県	医療法人健和会ひがみ耳鼻いんこう科・いびき睡眠クリニック 機関 A-0096-1 樋上 茂	〒689-3553　	鳥取県西伯郡日吉津村大字日吉津1584-3	0859-21-3387	http://www.higami.jp/	2024/12/20	中国	不要そう
89	岡山県	川崎医科大学附属病院 耳鼻咽喉科・頭頚部外科 機関 B-0037-1 原 浩貴	〒701-0192　	岡山県倉敷市松島577	086-462-1111	https://h.kawasaki-m.ac.jp/	2024/12/20	中国	要
90	広島県	広島大学病院睡眠医療センター 機関 A-0126 塩見 利明	〒734-8551　	広島県広島市南区霞1-2-3	082-257-5555	https://www.hiroshima-u.ac.jp/hosp/sinryoka/chuoshinryo/sleep	2024/12/23	中国	要
91	広島県	みんなの睡眠ストレスケアクリニック 機関 A-0135 山下 英尚	〒732-0066 	広島県広島市東区牛田本町2丁目1-2 ザ・パークハウス 2F	082-502-1300	https://minna-clinic.com/	2024/12/23	中国	不要
92	広島県	ちゃたに脳神経すいみんクリニック 脳神経内科 機関 A-0141 茶谷 裕	〒730-0051	広島県広島市中区大手町5-7-3ビアビアンカマツヲ　3F 	082-246-1811	https://chatani-naika.com/	2024/12/23	中国	不要
93	山口県	医療法人社団 土屋医院 心療内科・神経内科 機関 A-0031-4 土屋 智	〒755-0051　	山口県宇部市上町2丁目3番11号	0836-33-8116	http://tsuchiya1976.com/	2024/12/23	中国	不要
94	高知県	高知鏡川病院 睡眠医療センター 機関 A-0007-4 川田 誠一	〒780-8037	高知県高知市城山町270	088-833-4328	http://www.kagamigawa-hp.com/	2024/12/23	四国	不要
95	愛媛県	愛媛大学医学部附属病院 睡眠医療センター 機関 A-0106-2 岡 靖哲	〒791-0295 	愛媛県東温市志津川454	089-964-5111	https://www.hsp.ehime-u.ac.jp/	2024/12/23	四国	要
96	福岡県	福岡浦添クリニック 機関 A-0001-4 山口 祐司	〒810-0044	福岡県福岡市中央区六本松2-12-19 BCCビル9F	092-737-2111	https://urasoe-clinic.jp/	2024/12/26	九州	不要
97	福岡県	久留米大学病院 精神神経科 機関 A-0020-4 小曽根基裕	〒830-0011 	福岡県久留米市旭町67番地	0942-35-3311	https://www.hosp.kurume-u.ac.jp/	2024/12/26	九州	要
98	福岡県	医療法人眠りとこころの YOU クリニック 有吉祐睡眠クリニック 機関 A-0036-4 有吉 祐	〒802-0084 	福岡県北九州市小倉北区香春口1丁目13-1 メディックス三萩野2Ｆ	093-921-4133	https://you-sleepclinic.com/	2024/12/26	九州	不要
99	福岡県	国立病院機構福岡病院 睡眠センター 機関 A-0054-3 中野 博	〒811-1394 	福岡県福岡市南区屋形原4-39-1	092-565-5534	https://fukuoka.hosp.go.jp/	2024/12/26	九州	要
100	福岡県	恵友会霧ヶ丘つだ病院 機関 A-0078-3 津田 徹	〒802-0052	福岡県北九州市小倉北区霧ヶ丘3丁目9-20	093-921-0438	http://www.k-you.or.jp/	2024/12/26	九州	不要
101	福岡県	ふくおか睡眠クリニック 機関 A-0085-2 福留 武朗	〒810-0041　	福岡県福岡市中央区大名2丁目10-2 シャンボール大名B棟1301	092-400-2007	https://fukuoka-suimin.org/	2024/12/26	九州	不要
102	福岡県	坂本クリニック耳鼻咽喉科 機関 A-0122 坂本 菊男	〒800-0257 	福岡県北九州市小倉南区湯川1-3-23	093-923-3387	https://www.skmt-ent.jp/	2024/12/26	九州	不要
103	福岡県	九州大学病院 睡眠時無呼吸センター 機関 A-0128 重藤 寛史	〒812-8582 	福岡県福岡市東区馬出3-1-1	092-641-1151	https://www.hosp.kyushu-u.ac.jp/	2024/12/26	九州	要
104	福岡県	福岡県済生会二日市病院 機関 A-0136 安藤眞一	〒818-8516 	福岡県筑紫野市湯町3丁目13番1号	092-923-1551	https://www.saiseikai-futsukaichi.org/	2024/12/26	九州	要
105	福岡県	福岡大学病院 呼吸器内科 機関 A-0138 吉村 力	〒814-0180 	福岡県福岡市城南区七隈7-45-1	092-801-1011	https://www.hop.fukuoka-u.ac.jp/	2024/12/26	九州	要
106	長崎県	医療法人仁祐会小鳥居諌早病院 機関 A-0035-4 小鳥居 湛	〒854-0081 	長崎県諫早市栄田町38-16	0957-26-3374	http://www.kotorii.or.jp/	2024/12/26	九州	不要そう
107	長崎県	日本赤十字社長崎原爆諫早病院 呼吸器科 機関 A-0067-3 福島喜代康	〒859-0497　	長崎県諫早市多良見町化屋986番地2	0957-43-2111	http://isahaya.jrc.or.jp/	2024/12/26	九州	不要
108	長崎県	社会医療法人春回会 井上病院 呼吸器科 機関 A-0097-2 吉嶺 裕之	〒850-0045 	長崎県長崎市宝町6-12	0570-09-1014	https://www.shunkaikai.jp/inoue/	2024/12/26	九州	不要
109	長崎県	長崎大学病院 総合診療科 機関 A-0140 近藤 英明	〒852-8501 	長崎県長崎市坂本1丁目7番1号	095-819-7200	https://www.mh.nagasaki-u.ac.jp/	2024/12/26	九州	要
110	熊本県	社会医療法人芳和会 くわみず病院 機関 A-0061-3 池上あずさ	〒862-0954 	熊本県熊本市中央区神水1丁目14-41	096-381-2248	https://www.kuwamizu.jp/	2024/12/26	九州	不要
111	大分県	佐藤クリニック耳鼻咽喉科・頭頚部外科・睡眠呼吸障害センター機関 A-0071-3 佐藤 公則	〒870-0026 	大分県大分市金池町2-8-18	097-535-0480	https://www.sato-clinic.jp/	2024/12/26	九州	不要そう
112	宮崎県	潤和リハビリテーション振興財団 潤和会記念病院 神経内科 機関 A-0091-2 鶴田 和仁	〒880-2112	宮崎県宮崎市小松1119番地	0570-00-4755	https://www.junwakai.com/index.html	2024/12/26	九州	要
113	鹿児島県	医療法人聖心会 かごしま高岡病院 機関 A-0098-2 髙岡 俊夫	〒892-0847	鹿児島県鹿児島市西千石町14-12	099-226-1370	https://www.takaoka-hp.or.jp/	2024/12/26	九州	不要
114	沖縄県	医療法人エイチ・エス・アール 名嘉村クリニック 機関 A-0018-4 名嘉村 博	〒901-2132	沖縄県浦添市伊祖3-8-15	098-870-6600	http://nsleep.com/	2024/12/26	九州	不要`;

/**
 * 不正な値が与えられている際に throw されるエラー
 */
export class IllegalValueError extends Error {
  readonly name = "IllegalValueError";
  constructor(message: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
  }
}

/** 都道府県のリスト */
export const PREFECTURE_LIST = [
  "北海道",
  "青森県",
  "岩手県",
  "宮城県",
  "秋田県",
  "山形県",
  "福島県",
  "茨城県",
  "栃木県",
  "群馬県",
  "埼玉県",
  "千葉県",
  "東京都",
  "神奈川県",
  "新潟県",
  "富山県",
  "石川県",
  "福井県",
  "山梨県",
  "長野県",
  "岐阜県",
  "静岡県",
  "愛知県",
  "三重県",
  "滋賀県",
  "京都府",
  "大阪府",
  "兵庫県",
  "奈良県",
  "和歌山県",
  "鳥取県",
  "島根県",
  "岡山県",
  "広島県",
  "山口県",
  "徳島県",
  "香川県",
  "愛媛県",
  "高知県",
  "福岡県",
  "佐賀県",
  "長崎県",
  "熊本県",
  "大分県",
  "宮崎県",
  "鹿児島県",
  "沖縄県",
] as const;

/** 都道府県 */
export type Prefecture = (typeof PREFECTURE_LIST)[number];

/**
 * 引数の文字列が {@link Prefecture} か判定します。
 * type predicate を使用しているため、戻り値が true の場合、{@link Prefecture} にキャストします。
 *
 * **この関数は export して外部から呼び出されることを想定していません。**
 *
 * @param elm 検査対象
 * @returns {@link Prefecture} の場合、true
 */
function isPrefecture(elm: unknown): elm is Prefecture {
  return includes(PREFECTURE_LIST, elm);
}

/**
 * 引数の文字列が {@link Prefecture} か判定し、{@link Prefecture} だった場合キャストします。
 *
 * **この関数は export して外部から呼び出されることを想定していません。**
 *
 * @param elm 変換対象
 * @returns {@link Prefecture} にキャストした値
 * @throws IllegalValueError {@link Prefecture} ではない値が指定された場合
 */
function toPrefecture(elm: unknown): Prefecture {
  if (!isPrefecture(elm)) {
    throw new IllegalValueError(`不正な都道府県が設定されています：${elm}`);
  }
  return elm;
}

/** 八地方区分 */
const REGION_TYPE_LIST = [
  "北海道",
  "東北",
  "関東",
  "中部",
  "近畿",
  "中国",
  "四国",
  "九州",
] as const;

/** 八地方区分 */
export type RegionType = (typeof REGION_TYPE_LIST)[number];

/**
 * 引数の値が {@link RegionType} か判定します。
 * type predicate を使用しているため戻り値が true の場合、引数の値は {@link RegionType} にキャストされます。
 *
 * **この関数は export して外部から呼び出されることを想定していません。**
 *
 * @param elm 判定対象
 * @returns {@link RegionType} の場合、true
 */
function isRegionType(elm: unknown): elm is RegionType {
  return includes(REGION_TYPE_LIST, elm);
}

/**
 * 引数の文字列が {@link RegionType} か判定し、{@link RegionType} だった場合キャストします。
 *
 * **この関数は export して外部から呼び出されることを想定していません。**
 *
 * @param elm 変換対象
 * @returns {@link RegionType} にキャストした値
 * @throws IllegalValueError {@link RegionType} ではない値が指定された場合
 */
function toRegionType(elm: unknown): RegionType {
  if (!isRegionType(elm)) {
    throw new IllegalValueError(`不正な八地方区分が設定されています:${elm}`);
  }
  return elm;
}

/** 郵便番号 */
export type PostalCode = `〒${number}-${number}`;

/**
 * 引数の値が {@link PostalCode} か判定します。
 * type predicate を使用しているため戻り値が true の場合、引数の値は {@link PostalCode} にキャストされます。
 *
 * **この関数は export して外部から呼び出されることを想定していません。**
 *
 * @param elm 判定対象
 * @returns {@link PostalCode} の場合、true
 */
function isPostalCode(elm: string): elm is PostalCode {
  return /^〒\d{3}-\d{4}$/.test(elm);
}

/**
 * 引数の文字列が {@link PostalCode} に変換可能か判定し、{@link PostalCode} 変換可能だった場合、変換して返却します。
 *
 * **この関数は export して外部から呼び出されることを想定していません。**
 *
 * @param elm 変換対象
 * @returns {@link PostalCode} にキャストした値
 * @throws IllegalValueError {@link PostalCode} ではない値が指定された場合
 */
function toPostalCode(elm: string): PostalCode {
  const x = elm.replaceAll("−", "-").trim();
  if (!isPostalCode(x)) {
    throw new IllegalValueError(`不正な郵便番号が設定されています:${x}`);
  }
  return x;
}

/** 電話番号 */
type TelephoneNumber = `${number}-${number}` | `${number}-${number}-${number}`;
/** 電話番号フォーマット */
const TELEPHONE_NUMBER_FORMAT_LIST = [
  /^\d{2}-\d{4}-\d{4}$/,
  /^\d{3}-\d{3}-\d{4}$/,
  /^\d{4}-\d{2}-\d{4}$/,
  /^\d{4}-\d{3}-\d{3}$/,
];
/**
 * 引数の値が {@link TelephoneNumber} か判定します。
 * type predicate を使用しているため戻り値が true の場合、引数の値は {@link TelephoneNumber} にキャストされます。
 *
 * **この関数は export して外部から呼び出されることを想定していません。**
 *
 * @param elm 判定対象
 * @returns {@link PostCode} の場合、true
 */
function isTelephoneNumber(elm: string): elm is TelephoneNumber {
  return TELEPHONE_NUMBER_FORMAT_LIST.some((f) => f.test(elm));
}

/**
 * 引数の文字列が {@link TelephoneNumber} に変換可能か判定し、{@link TelephoneNumber} 変換可能だった場合、変換して返却します。
 *
 * **この関数は export して外部から呼び出されることを想定していません。**
 *
 * @param elm 変換対象
 * @returns {@link TelephoneNumber} にキャストした値
 * @throws IllegalValueError {@link TelephoneNumber} ではない値が指定された場合
 */
function toTelephoneNumber(elm: string): TelephoneNumber {
  const x = elm.replaceAll("−", "-").trim();
  if (!isTelephoneNumber(x)) {
    throw new IllegalValueError(`不正な電話番号が設定されています:${x}`);
  }
  return x;
}

/**
 * (施設名) (認定区分・番号) （代表者）をパースして、「施設名、認定区分・番号、代表者」を取得します。
 *
 * @param hospitalName (施設名) (認定区分・番号) （代表者）
 * @returns 施設名、認定区分・番号、代表者
 */
function parseHospitalName(hospitalName: string): {
  /** 施設名 */
  name: string;
  /** 認定区分・番号 */
  certificationType: string;
  /** 代表者 */
  representativeName: string;
} {
  const re = /^(.+?)[ |　]?機関 ([A-Z]-[a]?\d{3,4}(-\d)?)[ |　](.+)$/.exec(
    hospitalName
  );
  if (re == null) {
    throw new IllegalValueError(
      `不正な(施設名) (認定区分・番号) （代表者）が設定されています:${hospitalName}`
    );
  }
  const [, name, certificationType, , representativeName] = re;
  return { name, certificationType, representativeName };
}

/**
 * 日本睡眠学会専門医療機関情報
 */
export interface SleepHospital {
  /** No */
  readonly no: number;
  /** 都道府県 */
  readonly prefecture: Prefecture;
  /** 施設名 */
  readonly name: string;
  /** 認定区分・番号 */
  readonly certificationType: string;
  /** 代表者 */
  readonly representativeName: string;
  /** 郵便番号 */
  readonly postalCode: PostalCode;
  /** 住所 */
  readonly address: string;
  /** 電話番号 */
  readonly tel: TelephoneNumber;
  /** HP(=引用元) */
  readonly url: string;
  /** 参照日 */
  readonly referenceDate: Date;
  /** 地方(八地方区分) */
  readonly regionType: RegionType;
  /** 選定療養費 */
  readonly needNonReferralFee: boolean;
}

/** 施設リスト */
export const SLEEP_HOSPITAL_LIST: readonly SleepHospital[] =
  HOSPITAL_DATA.split("\n")
    .slice(1)
    .map((line) => line.split("\t"))
    .filter((cols) => cols.at(-1) !== "閉業")
    .map<SleepHospital>(
      ([
        no,
        prefecture,
        hospitalName,
        postalCode,
        address,
        tel,
        url,
        referenceDate,
        regionType,
        needNonReferralFee,
      ]) => ({
        no: Number(no),
        prefecture: toPrefecture(prefecture),
        postalCode: toPostalCode(postalCode),
        ...parseHospitalName(hospitalName),
        address,
        tel: toTelephoneNumber(tel),
        url,
        referenceDate: new Date(referenceDate),
        regionType: toRegionType(regionType),
        needNonReferralFee: needNonReferralFee === "要",
      })
    );

/** 施設都道府県リスト */
export const SLEEP_HOSPITAL_PREFECTURE_LIST: readonly Prefecture[] = Array.from(
  new Set(SLEEP_HOSPITAL_LIST.map((v) => v.prefecture))
);
